



























import { Component, Vue, Prop } from 'vue-property-decorator';
import dxCustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import notificationService from '@/services/notificationService';
import externalInvoicesRepository from '@/modules/externalInvoices/externalInvoicesRepository';
import Popup from '@/components/default/Popup.vue';
import Datagrid from '@/components/default/Datagrid.vue';
import DxFileUploader from 'devextreme-vue/file-uploader';
import { ExternalInvoiceStatus, ExternalInvoiceType } from '@/modules/externalInvoices/enums';

@Component({
  components: {
    Datagrid,
    Popup,
    DxFileUploader,
  },
})
export default class ExternalInvoicesTable extends Vue {
    @Prop({required: false, default: ''})
    private projectId!: string;

    @Prop({required: false, default: ''})
    private supplierId!: string;

    @Prop({ required: false, default: false })
    public disabled!: boolean;

    private showAddPopup: boolean = false;
    private guidList: any[] = [];

    private editRow(e: any) {
        if (e && e.row && !e.row.isEditing && e.column && e.column.type !== 'buttons') {
            this.$router.push({ path: `/externalinvoices/${e.data.id}`, query: { checkProjectOnHold: this.projectId ? 'false' : 'true' } });
        }
    }

    private async deleteRow(e: any) {
        const self = this;
        e.cancel = new Promise(async (resolve, reject) => {
            try {
                await externalInvoicesRepository.delete(e.data.id);
                notificationService.saved();
                setTimeout(() => {
                    self.refresh();
                }, 300);
                resolve(false);
            } catch (err) {
                notificationService.showAxiosError(err);
                resolve(true);
            }
        });
    }

    private refresh() {
      try {
        ((this.$refs.grid as Datagrid).$refs.externalInvoicesGrid as any).instance.refresh();
      } catch {
        // do nothing
      }
    }

    private async uploadChunk(file: any, uploadInfo: any) {
        try {
            const item = this.guidList.find((i) => i.name === file.name);

            const dto: IUploadChunkDto = {
                file: uploadInfo.chunkBlob,
                path: '',
                metaData: {
                index: uploadInfo.chunkIndex,
                totalCount: uploadInfo.chunkCount,
                fileSize: file.size,
                fileType: file.type,
                fileName: file.name,
                fileGuid: item ? item.guid : '',
                },
            };

            const result = (await externalInvoicesRepository.create(dto, this.projectId)).data;

            const guidItems = this.guidList.filter((guidItem) => guidItem.name === file.name);
            if (guidItems.length > 0) {
                if (result.completed) {
                    guidItems.forEach((guidItem) => {
                        const index = this.guidList.indexOf(guidItem);
                        this.guidList.splice(index, 1);
                    });
                }
            } else {
                if (!result.completed) {
                    this.guidList.push({
                        name: file.name,
                        guid: result.guid,
                    });
                }
            }

            if (result.completed) {
                notificationService.showSuccessMessage('Bestand is geüpload');
                this.showAddPopup = false;
                this.$router.push({ path: `/externalinvoices/${(result as any).objectId}` });
            }
        } catch (err) {
            notificationService.showErrorMessage('Er is iets misgelopen tijdens het uploaden');
        }
    }

    get columns() {
        const self = this;
        const columns: any[] = [
            {
                dataField: 'documentNumber',
                caption: 'Documentnr.',
            },
            {
                dataField: 'invoiceNumber',
                caption: 'Factuurnr.',
            },
            {
                dataField: 'internalReference',
                caption: 'Interne referentie',
            },
            {
                dataField: 'supplierName',
                caption: 'Leverancier',
            },
            {
                dataField: 'projectName',
                caption: 'Projectnaam',
            },
            {
                dataField: 'approverId',
                caption: 'Verantwoordelijke',
                lookup: {
                    dataSource: this.$store.getters['employees/items'],
                    valueExpr: 'id',
                    displayExpr: 'displayName',
                },
            },
            {
                dataField: 'status',
                caption: 'Status',
                lookup: {
                    dataSource: [
                        { value: ExternalInvoiceStatus.Received, text: 'Ontvangen' },
                        { value: ExternalInvoiceStatus.Accepted, text: 'Aanvaard' },
                        { value: ExternalInvoiceStatus.Rejected, text: 'Afgewezen' },
                        { value: ExternalInvoiceStatus.Paid, text: 'Betaald' },
                    ],
                    valueExpr: 'value',
                    displayExpr: 'text',
                },
            },
            {
                dataField: 'type',
                caption: 'Soort',
                lookup: {
                    dataSource: [
                        { value: ExternalInvoiceType.MaterialsOrder, text: 'Materiaal' },
                        { value: ExternalInvoiceType.SubcontractorSettlement, text: 'Afrekening OA' },
                        { value: ExternalInvoiceType.Other, text: 'Andere' },
                    ],
                    valueExpr: 'value',
                    displayExpr: 'text',
                },
            },
            {
                dataField: 'date',
                caption: 'Datum',
                dataType: 'date',
                format: 'dd/MM/yyyy',
            },
            {
                dataField: 'dueDate',
                caption: 'Vervaldatum',
                dataType: 'date',
                format: 'dd/MM/yyyy',
            },
            {
                dataField: 'receivedDate',
                caption: 'Ontvangen op',
                dataType: 'date',
                format: 'dd/MM/yyyy',
            }
        ];

        if (!this.disabled) {
            columns.push({
                type: 'buttons',
                buttons: ['edit', 'delete'],
            });
        }

        return columns;
    }

    get datasource() {
        const self = this;
        return new DataSource({
            store: new dxCustomStore({
                key: 'id',
                load: async (loadOptions) => {
                /*data: result.data.data,
                    totalCount: result.data.totalCount,*/
                    const result = await externalInvoicesRepository
                        .lookup(loadOptions, this.projectId, this.supplierId);
                    return result.data;
                },
                remove: async (key) => {
                    return;
                },
            }),
            paginate: true,
        });
    }

    get toolbarOptions() {
        return [
            {
                location: 'before',
                widget: 'dxButton',
                options: {
                    icon: 'fas fa-plus',
                    text: 'Toevoegen',
                    stylingMode: 'outlined',
                    type: 'success',
                    onClick: () => {
                            this.showAddPopup = true;
                    },
                    disabled: this.disabled
                },
            },
        ];
    }
}
